import { selectChecklistState } from '../index';
import { createSelector } from '@ngrx/store';
import { ChecklistState } from '../reducers/checklist.reducer';

export const selectChecklists = createSelector(
  selectChecklistState,
  (state: ChecklistState) => state && state.checklists
);
export const selectChecklistsLoading = createSelector(
  selectChecklistState,
  (state: ChecklistState) => state && state.loading
);
export const selectChecklistsError = createSelector(
  selectChecklistState,
  (state: ChecklistState) => state && state.error
);
